<template>
  <div class="px-3">
    <div v-if="isAdmin || isReceiver">
      <div class="sticky">
        <h1 class="text-center">
          <span>
            ПРИЕМЩИКИ
          </span>
        </h1>

        <div class="row">
          <div class="col-2">
            <button
              v-if="isAdmin"
              class="btn btn-lg btn-primary text-center berry"
              @click="addUser()"
            >
              ДОБАВИТЬ
            </button>
          </div>

          <div class="col-2">
            <button class="btn btn-lg btn-info text-center berry" @click="showSaveSettings()">
              НАСТРОЙКИ
            </button>
          </div>

          <div class="col">
            <Multiselect
              v-model="currentMaster"
              :options="usersWholesaler"
              :loading="false"
              :internal-search="false"
              valueProp="_id"
              trackBy="fullname"
              label="fullname"
              :filterResults="true"
              :minChars="2"
              :resolveOnLoad="true"
              :searchable="true"
              class="deliverer"
              noOptionsText="Не найден"
              placeholder="Оптовик"
            >
            </Multiselect>
          </div>

          <div class="col">
            <input
              type="text"
              class="form-control center"
              placeholder="Поиск"
              v-model="searchText"
            />
          </div>
        </div>

        <div class="row mt-2">
          <div v-if="showSettings" class="col">
            <div>
              <table class="table w-50">
                <thead>
                  <th>Наименование столбца</th>
                  <th>Отображать</th>
                </thead>
                <tbody>
                  <tr v-for="(field, index) in Object.keys(tableSettings)" :key="index">
                    <td>{{ tableSettings[field].label }}</td>
                    <td>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="tableSettings[field].show"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="tableFixHead mt-1">
        <table v-if="!loading" class="table">
          <thead>
            <th></th>
            <th></th>
            <th v-for="(field, index) in tableSettingsHeader" :key="index">
              {{ field.label }}
            </th>
          </thead>

          <tbody>
            <tr
              v-for="(user, index) in usersFilter"
              :key="user._id"
              :class="{ wholesaler: user.wholesaler }"
            >
              <td>
                <button
                  v-if="user.wholesaler"
                  class="btn btn-light fs-5"
                  @click="setUserVisability(user)"
                >
                  <strong>+</strong>
                </button>
              </td>
              <td>
                <div class="col pt-1 btn-group">
                  <button
                    type="submit"
                    :form="`form-user-${index}`"
                    class="btn btn-light w-100"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Сохранить данные пользователя"
                  >
                    <font-awesome-icon icon="save" />
                    <div v-if="user.loadingSave" class="spinner-border" role="status">
                      <span class="sr-only"></span>
                    </div>
                  </button>

                  <button
                    @click.prevent="user.edit = user.edit ? false : true"
                    :form="`form-user-${index}`"
                    class="btn btn-light w-100"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Редактировать данные пользователя"
                  >
                    <font-awesome-icon icon="user-edit" />
                  </button>

                  <!-- Modal -->
                  <div
                    class="modal fade"
                    :id="`remove-user-confirm-${user._id}`"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">
                            Внимание!
                          </h5>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="modal-body">
                          Вы действительно хотите удалить пользователя "{{
                            user.receiver.fullname
                          }}"?
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            Нет
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger"
                            data-bs-dismiss="modal"
                            @click="removeUser(user)"
                          >
                            Да
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td v-if="tableSettings.fullname.show">
                <form @submit="saveUser(user, index, $event)" :id="`form-user-${index}`">
                  <input
                    v-if="user.edit && isAdmin"
                    class="form-control p-1"
                    v-model="user.receiver.fullname"
                    type="text"
                    required
                  />
                  <span v-else>{{ user.receiver.fullname }}</span>
                </form>
              </td>

              <td v-if="tableSettings.inn.show">
                <input
                  v-if="user.edit && isAdmin"
                  :form="`form-user-${index}`"
                  class="form-control p-1"
                  v-model="user.receiver.inn"
                  type="text"
                />
                <span v-else>{{ user.receiver.inn }}</span>
              </td>

              <td v-if="tableSettings.address.show">
                <input
                  v-if="user.edit && isAdmin"
                  :form="`form-user-${index}`"
                  class="form-control p-1"
                  v-model="user.receiver.address"
                  type="text"
                />
                <span v-else>{{ user.receiver.address }}</span>
              </td>

              <td v-if="tableSettings.prefix.show">
                <input
                  v-if="user.edit && isAdmin"
                  :form="`form-user-${index}`"
                  class="form-control p-1"
                  v-model="user.receiver.prefix"
                  type="text"
                  required
                />
                <span v-else>{{ user.receiver.prefix }}</span>
              </td>

              <td v-if="tableSettings.email.show">
                <input
                  v-if="user.edit && isAdmin"
                  :form="`form-user-${index}`"
                  class="form-control p-1"
                  v-model="user.email"
                  type="email"
                  required
                />
                <span v-else>{{ user.email }}</span>
              </td>

              <td v-if="tableSettings.phone.show" style="min-width: 150px">
                <div class="input-group" v-if="user.edit && isAdmin">
                  <span class="input-group-text p-1" id="basic-addon1">+7</span>
                  <input
                    id="phone"
                    :form="`form-user-${index}`"
                    class="form-control p-1"
                    v-model="user.phone"
                    type="tel"
                    pattern="[0-9]{10}"
                    placeholder="1234567890"
                  />
                </div>
                <span v-else>+7{{ user.phone }}</span>
              </td>

              <td v-if="tableSettings.role.show" style="min-width: 250px">
                <div class="input-group">
                  <select
                    v-model="user.role"
                    :form="`form-user-${index}`"
                    class="form-select w-75"
                    :disabled="!user.edit || !isAdmin"
                    required
                  >
                    <option value="" selected>Выберите роль</option>
                    <option v-for="roleItem in roles" :key="roleItem._id" :value="roleItem._id">
                      {{ roleItem.label }}
                    </option>
                  </select>
                </div>
              </td>

              <td v-if="tableSettings.master.show" style="min-width: 200px">
                <Multiselect
                  v-if="!isRole(user.role, 'wholesaler') && !isRole(user.role, 'receiver')"
                  v-model="user.receiver.master"
                  :options="usersWholesaler"
                  :loading="false"
                  :internal-search="false"
                  valueProp="_id"
                  trackBy="fullname"
                  label="fullname"
                  :filterResults="true"
                  :minChars="2"
                  :resolveOnLoad="true"
                  :searchable="true"
                  noOptionsText="Не найден"
                  :disabled="!user.edit || !isAdmin"
                  required
                >
                </Multiselect>
              </td>

              <td v-if="tableSettings.submaster.show" style="min-width: 200px">
                <Multiselect
                  v-if="!isRole(user.role, 'wholesaler') && !isRole(user.role, 'receiver')"
                  v-model="user.receiver.subMaster"
                  :options="usersSubMaster(user.receiver.master)"
                  :loading="false"
                  :internal-search="false"
                  valueProp="_id"
                  trackBy="fullname"
                  label="fullname"
                  :filterResults="true"
                  :minChars="2"
                  :resolveOnLoad="true"
                  :searchable="true"
                  noOptionsText="Не найден"
                  :disabled="!user.edit || !isAdmin"
                >
                </Multiselect>
              </td>

              <td v-if="tableSettings.emailActive.show">
                <input
                  class="form-check-input"
                  :form="`form-user-${index}`"
                  type="checkbox"
                  :id="`flexSwitchActive-${user._id}`"
                  v-model="user.active"
                  :disabled="!user.edit || !isAdmin"
                />
              </td>

              <td v-if="tableSettings.active.show">
                <input
                  class="form-check-input"
                  :form="`form-user-${index}`"
                  type="checkbox"
                  :id="`flexSwitchChecked-${user._id}`"
                  v-model="user.checked"
                  :disabled="!user.edit || !isAdmin"
                />
              </td>

              <td v-if="tableSettings.setPassword.show">
                <input
                  class="form-check-input"
                  :form="`form-user-${index}`"
                  type="checkbox"
                  :id="`flexSwitchPassword-${user._id}`"
                  v-model="user.setPassword"
                  :disabled="!user._id || !isAdmin"
                />
              </td>

              <td v-if="tableSettings.password.show" style="min-width: 150px">
                <input
                  v-if="user.setPassword"
                  :form="`form-user-${index}`"
                  class="form-control p-1"
                  v-model="user.password"
                  type="text"
                  required
                />
              </td>

              <td v-if="tableSettings.passwordNew.show" style="min-width: 150px">
                <input
                  :form="`form-user-${index}`"
                  class="form-control p-1"
                  v-model="user.password2"
                  type="text"
                />
              </td>

              <td v-if="tableSettings.bonus.show">
                <input
                  v-if="user.edit && isAdmin"
                  class="form-control p-1"
                  :form="`form-user-${index}`"
                  v-model="user.bonus"
                  type="number"
                  step="0.01"
                />
                <input
                  v-else
                  class="form-control p-1 font-weight-bold"
                  :form="`form-user-${index}`"
                  v-model="user.bonus"
                  type="number"
                  disabled
                />
              </td>

              <td v-if="tableSettings.logist.show">
                <input
                  v-if="user.edit && isAdmin"
                  class="form-control p-1"
                  :form="`form-user-${index}`"
                  v-model="user.receiver.logist"
                  type="number"
                  step="0.01"
                />
                <input
                  v-else
                  class="form-control p-1 font-weight-bold"
                  :form="`form-user-${index}`"
                  v-model="user.receiver.logist"
                  type="number"
                  disabled
                />
              </td>

              <td v-if="tableSettings.cost.show">
                <input
                  v-if="user.edit && isAdmin"
                  class="form-control p-1"
                  :form="`form-user-${index}`"
                  v-model="user.receiver.cost"
                  type="number"
                  step="0.01"
                />
                <input
                  v-else
                  class="form-control p-1 font-weight-bold"
                  :form="`form-user-${index}`"
                  v-model="user.receiver.cost"
                  type="number"
                  disabled
                />
              </td>

              <td v-if="tableSettings.commentFB.show" style="min-width: 200px">
                <input
                  :disabled="!user.edit || !isAdmin"
                  :form="`form-user-${index}`"
                  class="form-control p-1 font-weight-bold"
                  v-model="user.commentFB"
                  type="text"
                />
              </td>

              <td v-if="tableSettings.commentUser.show" style="min-width: 200px">
                <input
                  :disabled="!user.edit"
                  :form="`form-user-${index}`"
                  class="form-control p-1 font-weight-bold"
                  v-model="user.commentUser"
                  type="text"
                />
              </td>

              <td v-if="tableSettings.guid1c.show" style="min-width: 350px">
                <input
                  :disabled="!user.edit || !isAdmin"
                  :form="`form-user-${index}`"
                  class="form-control p-1 font-weight-bold"
                  v-model="user.guid1C"
                  type="text"
                />
              </td>

              <td>
                <button
                  v-if="isAdmin"
                  class="btn btn-light w-100"
                  :form="`form-user-${index}`"
                  data-bs-toggle="modal"
                  :data-bs-target="`#remove-user-confirm-${user._id}`"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Удалить пользователя"
                  type="button"
                >
                  <font-awesome-icon icon="trash" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="false" class="main-content">
        <div v-if="!loading" class="container">
          <div
            v-for="(user, index) in usersFilter"
            :key="user._id"
            class="card lh-1 mb-3"
            style="max-width: 400px"
          >
            <div v-if="!user.delete" class="card-body">
              <form @submit="saveUser(user, index, $event)">
                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted"><small>Наименование</small></div>
                  <div class="col text-muted"><small>ИНН</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.receiver.fullname"
                      type="text"
                      required
                    />
                    <span v-else>{{ user.receiver.fullname }}</span>
                  </div>

                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.receiver.inn"
                      type="text"
                    />
                    <span v-else>{{ user.receiver.inn }}</span>
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted"><small>Адрес</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.receiver.address"
                      type="text"
                    />
                    <span v-else>{{ user.receiver.address }}</span>
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted"><small>Префикс</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.receiver.prefix"
                      type="text"
                      required
                    />
                    <span v-else>{{ user.receiver.prefix }}</span>
                  </div>
                </div>

                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted"><small>Email</small></div>
                  <div class="col text-muted"><small>Телефон</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.email"
                      type="email"
                      required
                    />
                    <span v-else>{{ user.email }}</span>
                  </div>
                  <div class="col">
                    <div class="input-group" v-if="user.edit && isAdmin">
                      <span class="input-group-text p-1" id="basic-addon1">+7</span>
                      <input
                        id="phone"
                        class="form-control p-1"
                        v-model="user.phone"
                        type="tel"
                        pattern="[0-9]{10}"
                        placeholder="1234567890"
                      />
                    </div>
                    <span v-else>+7{{ user.phone }}</span>
                  </div>
                </div>

                <div class="row row-cols-1 pt-0">
                  <div class="col pt-1">
                    <div class="input-group">
                      <select
                        v-model="user.role"
                        class="form-select w-75"
                        :disabled="!user.edit || !isAdmin"
                        required
                      >
                        <option value="" selected>Выберите роль</option>
                        <option v-for="roleItem in roles" :key="roleItem._id" :value="roleItem._id">
                          {{ roleItem.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!isRole(user.role, 'wholesaler') && !isRole(user.role, 'receiver')"
                  class="row row-cols-1 pt-0 mt-2"
                >
                  <div class="col text-muted"><small>Оптовый пункт</small></div>
                  <div class="col">
                    <Multiselect
                      v-model="user.receiver.master"
                      :options="usersWholesaler"
                      :loading="false"
                      :internal-search="false"
                      valueProp="_id"
                      trackBy="fullname"
                      label="fullname"
                      :filterResults="true"
                      :minChars="2"
                      :resolveOnLoad="true"
                      :searchable="true"
                      class="deliverer"
                      style="min-height: 3rem"
                      noOptionsText="Не найден"
                      :disabled="!user.edit || !isAdmin"
                      required
                    >
                    </Multiselect>
                  </div>
                  <div class="col text-muted mt-2">
                    <small>Вышестоящий приемщик</small>
                  </div>
                  <div class="col">
                    <Multiselect
                      v-model="user.receiver.subMaster"
                      :options="usersSubMaster(user.receiver.master)"
                      :loading="false"
                      :internal-search="false"
                      valueProp="_id"
                      trackBy="fullname"
                      label="fullname"
                      :filterResults="true"
                      :minChars="2"
                      :resolveOnLoad="true"
                      :searchable="true"
                      class="deliverer"
                      style="min-height: 3rem"
                      noOptionsText="Не найден"
                      :disabled="!user.edit || !isAdmin"
                    >
                    </Multiselect>
                  </div>
                </div>

                <div class="row row-cols-2 mt-2">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`flexSwitchActive-${user._id}`"
                        v-model="user.active"
                        :disabled="!user.edit || !isAdmin"
                      />
                      <label class="form-check-label" :for="`flexSwitchActive-${user._id}`"
                        ><small>Email подтвержден</small></label
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`flexSwitchChecked-${user._id}`"
                        v-model="user.checked"
                        :disabled="!user.edit || !isAdmin"
                      />
                      <label class="form-check-label" :for="`flexSwitchChecked-${user._id}`"
                        ><small>Пользователь активен</small></label
                      >
                    </div>
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`flexSwitchPassword-${user._id}`"
                        v-model="user.setPassword"
                        :disabled="!user._id || !isAdmin"
                      />
                      <label class="form-check-label" :for="`flexSwitchPassword-${user._id}`"
                        ><small>Новый пароль</small></label
                      >
                    </div>
                    <input
                      v-if="user.setPassword"
                      class="form-control p-1"
                      v-model="user.password"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div class="row row-cols-4 mt-2">
                  <div class="col text-muted">
                    <small>БОНУС, у.е./кг</small>
                  </div>
                  
                  <div class="col text-muted">
                    <small>ЛОГИСТИКА, у.е./кг</small>
                  </div>
                  <div class="col text-muted">
                    <small>ДОП. ЗАТРАТЫ, у.е./кг</small>
                  </div>
                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.bonus"
                      type="number"
                      step="0.01"
                    />
                    <input
                      v-else
                      class="form-control p-1 font-weight-bold"
                      v-model="user.bonus"
                      type="number"
                      disabled
                    />
                  </div>


                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.receiver.logist"
                      type="number"
                      step="0.01"
                    />
                    <input
                      v-else
                      class="form-control p-1 font-weight-bold"
                      v-model="user.receiver.logist"
                      type="number"
                      disabled
                    />
                  </div>

                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.receiver.cost"
                      type="number"
                      step="0.01"
                    />
                    <input
                      v-else
                      class="form-control p-1 font-weight-bold"
                      v-model="user.receiver.cost"
                      type="number"
                      disabled
                    />
                  </div>
                </div>

                <div v-if="false" class="row row-cols-4 mt-2">
                  <div class="col text-muted">
                    <small></small>
                  </div>
                  <div class="col text-muted">
                    <small></small>
                  </div>
                  <div class="col text-muted">
                    <small>МАКС</small>
                  </div>
                  <div class="col text-muted">
                    <small></small>
                  </div>

                  <div class="col"></div>
                  <div class="col"></div>
                  <div class="col">
                    <input
                      v-if="user.edit && isAdmin"
                      class="form-control p-1"
                      v-model="user.receiver.logistMax"
                      type="number"
                      step="0.01"
                    />
                    <input
                      v-else
                      class="form-control p-1 font-weight-bold"
                      v-model="user.receiver.logistMax"
                      type="number"
                      disabled
                    />
                  </div>
                  <div class="col"></div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted">
                    <small>Комментарий ФБ</small>
                  </div>

                  <input
                    :disabled="!user.edit || !isAdmin"
                    class="form-control p-1 font-weight-bold"
                    v-model="user.commentFB"
                    type="text"
                  />
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted">
                    <small>Комментарий пользователя</small>
                  </div>

                  <input
                    :disabled="!user.edit"
                    class="form-control p-1 font-weight-bold"
                    v-model="user.commentUser"
                    type="text"
                  />
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted">
                    <small>Идентификатор 1С (guid1C)</small>
                  </div>

                  <input
                    :disabled="!user.edit || !isAdmin"
                    class="form-control p-1 font-weight-bold"
                    v-model="user.guid1C"
                    type="text"
                  />
                </div>
                <div class="row row-cols-1 pt-2">
                  <div class="col pt-1 btn-group">
                    <button
                      type="submit"
                      class="btn btn-light w-100"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Сохранить данные пользователя"
                    >
                      <font-awesome-icon icon="save" />
                      <div v-if="user.loadingSave" class="spinner-border" role="status">
                        <span class="sr-only"></span>
                      </div>
                    </button>

                    <button
                      @click.prevent="user.edit = user.edit ? false : true"
                      class="btn btn-light w-100"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Редактировать данные пользователя"
                    >
                      <font-awesome-icon icon="user-edit" />
                    </button>

                    <button
                      v-if="isAdmin"
                      class="btn btn-light w-100"
                      data-bs-toggle="modal"
                      :data-bs-target="`#remove-user-confirm-${user._id}`"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Удалить пользователя"
                      type="button"
                    >
                      <font-awesome-icon icon="trash" />
                    </button>
                    <!-- Modal -->
                    <div
                      class="modal fade"
                      :id="`remove-user-confirm-${user._id}`"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                              Внимание!
                            </h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            Вы действительно хотите удалить пользователя "{{
                              user.receiver.fullname
                            }}"?
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                              Нет
                            </button>
                            <button
                              type="button"
                              class="btn btn-danger"
                              data-bs-dismiss="modal"
                              @click="removeUser(user)"
                            >
                              Да
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div v-if="loading" class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref, computed, onMounted } from "vue";
import useCommonMixin from "@/components/commonMixin.js";
import Multiselect from "@vueform/multiselect";

export default {
  name: "UsersReceive",
  components: {
    Multiselect
  },
  props: {
    profile: { type: Boolean, default: false }
  },
  setup(props) {
    const store = useStore();
    const users = ref([]);
    const { asyncForEach, isAdmin, isReceiver } = useCommonMixin();
    const loading = ref(true);
    const roles = ref([]);
    const receivers = ref([]);
    const searchText = ref("");
    const currentMaster = ref();

    const tableSettings = ref({
      fullname: { show: true, label: "Наименование" },
      inn: { show: true, label: "ИНН" },
      address: { show: true, label: "Адрес" },
      prefix: { show: true, label: "Префикс" },
      email: { show: true, label: "Email" },
      phone: { show: true, label: "Телефон" },
      role: { show: true, label: "Роль" },
      master: { show: true, label: "Оптовик" },
      submaster: { show: true, label: "Вышестоящий приемщик" },
      emailActive: { show: true, label: "Email" },
      active: { show: true, label: "Активен" },
      setPassword: { show: true, label: "Новый пароль" },
      password: { show: true, label: "Пароль" },
      passwordNew: { show: true, label: "Пароль2" },
      bonus: { show: true, label: "БОНУС" },
      // shrink: { show: true, label: "УСУШКА" },
      logist: { show: true, label: "ЛОГИСТИКА" },
      cost: { show: true, label: "ДОП. ЗАТРАТЫ" },
      commentFB: { show: true, label: "Коммент ФБ" },
      commentUser: { show: true, label: "Коммент пользователя" },
      guid1c: { show: true, label: "guid1C" }
    });
    const showSettings = ref(false);

    const init = async () => {
      const tableSettingsLocalStorage = JSON.parse(localStorage.getItem("tableSettings"));
      console.log("tableSettingsLocalStorage", tableSettingsLocalStorage);
      if (tableSettingsLocalStorage && Object.keys(tableSettingsLocalStorage).length > 0) {
        tableSettings.value = tableSettingsLocalStorage;
      }

      loading.value = true;
      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter(role => role.type != "deliverer")
        : [];

      let response = await store.dispatch("FETCHuser", props.profile ? "profile" : "receiver");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async user => {
        user.wholesaler = isRole(user.role, "wholesaler");
        user.show = isRole(user.role, "wholesaler") ? true : false;
        user.phone = user.phone ? user.phone.slice(2, 12) : "";
        user.fullname = user.receiver.fullname;
        user.slaveShow = false;
      });

      loading.value = false;
    };

    const saveUser = async (user, userIndex, event) => {
      event.preventDefault();
      users.value[userIndex].loadingSave = true;
      user.password = user.setPassword ? user.password : null;
      let response = await store.dispatch("POSTuser", user);
      console.log("response.status", response.status);
      if (response.status) {
        user._id = response.data.message._id;
        user.edit = false;
        user.setPassword = false;
      }
      users.value[userIndex].loadingSave = false;
    };

    const addUser = async () => {
      users.value.unshift({
        receiver: {
          fullname: "",
          inn: "",
          address: "",
          prefix: "",
          shrink: 0,
          logist: 0
        },
        username: "",
        phone: "",
        email: "",
        role: "receiver",
        password: "",
        setPassword: true,
        edit: true,
        bonus: 0,
        _id: null
      });
    };

    const removeUser = async user => {
      user.delete = true;
      let remove = await store.dispatch("POSTuser", user);
      user.delete = remove.status ? true : false;
    };

    const fetchReceiver = async query => {
      console.log("query", query);
      let user = [{ _id: "", fullname: "" }];
      if (query && query.length == 11) {
        let response = await store.dispatch("FETCHuserProfile", {
          userId: null,
          phone: query
        });
        user = response ? response : { _id: "", fullname: "" };
        user.fullname = `${user.receiver.fullname}`;
        let receiverIndex = receivers.value.findIndex(item => item._id == user._id);
        if (receiverIndex < 0) {
          receivers.value.push(user);
        }
      }
    };

    const usersWholesaler = computed(() => {
      let result = [];
      let wholesalerRole = roles.value.find(item => item.name == "wholesaler");
      result = wholesalerRole ? users.value.filter(item => item.role == wholesalerRole._id) : [];
      console.log("result", result);
      return result;
    });

    const usersSubMaster = computed(() => {
      return master => {
        let result = users.value.filter(item => item.receiver.master == master);
        return result;
      };
    });

    const isRole = (roleId, roleName) => {
      let role = roles.value.find(item => {
        return item._id == roleId && item.name == roleName;
      });
      return role ? true : false;
    };

    const usersFilter = computed(() => {
      let result = users.value.filter(user => user.show || !user._id);

      if (currentMaster.value) {
        result = result.filter(user => user.receiver.master == currentMaster.value);
      }

      if (searchText.value.length >= 2) {
        result = result.filter(user => {
          return (
            JSON.stringify(user)
              .toLowerCase()
              .indexOf(searchText.value.toLowerCase()) >= 0 && !user.delete
          );
        });
      } else {
        result = result.filter(user => !user.delete);
      }
      return result;
    });

    const setUserVisability = masterUser => {
      masterUser.slaveShow = masterUser.slaveShow ? false : true;

      let slaveShow = masterUser.slaveShow;

      users.value.forEach(user => {
        if (user.receiver.master == masterUser._id && !user.wholesaler) {
          user.show = slaveShow;
        }
      });

      //masterUser.slaveShow = slaveShow ? false : true;
    };

    const tableSettingsHeader = computed(() => {
      let result = [];
      Object.keys(tableSettings.value).forEach(key => {
        if (tableSettings.value[key].show) {
          result.push(tableSettings.value[key]);
        }
      });
      return result;
    });

    const showSaveSettings = () => {
      showSettings.value = showSettings.value ? false : true;
      localStorage.setItem("tableSettings", JSON.stringify(tableSettings.value));
    };

    onMounted(init);
    return {
      users,
      loading,
      saveUser,
      isAdmin,
      isReceiver,
      addUser,
      removeUser,
      roles,
      fetchReceiver,
      receivers,
      usersWholesaler,
      isRole,
      searchText,
      usersFilter,
      usersSubMaster,
      currentMaster,
      setUserVisability,
      tableSettings,
      tableSettingsHeader,
      showSettings,
      showSaveSettings
    };
  }
};
</script>

<style>
.wholesaler {
  background-color: beige;
}
</style>
